import styled from "styled-components";

export const StyledTravelMapWrapper = styled.div`
  height: 300px;
  @media print {
    display: none;
  }
`;
